const colors = {
  "a":[226, 95, 81],
  "b":[242, 96, 145], 
  "c":[187, 101, 202], 
  "d":[149, 114, 207], 
  "e":[120, 132, 205], 
  "f":[91, 149, 249], 
  "g":[72, 194, 249], 
  "h":[69, 208, 226], 
  "i":[72, 182, 172], 
  "j":[82, 188, 137], 
  "k":[155, 206, 95], 
  "l":[212, 227, 74], 
  "m":[254, 218, 16], 
  "n":[247, 192, 0], 
  "o":[255, 168, 0], 
  "p":[255, 138, 96], 
  "q":[194, 194, 194], 
  "r":[143, 164, 175], 
  "s":[162, 136, 126], 
  "t":[163, 163, 163], 
  "u":[175, 181, 226], 
  "v":[179, 155, 221], 
  "w":[194, 194, 194], 
  "x":[124, 222, 235], 
  "y":[188, 170, 164], 
  "z":[173, 214, 125] 
}


const getRGB = (name) =>{
  return "rgb("+colors[name[0]][0]+","+colors[name[0]][1]+","+colors[name[0]][2]+")"
}

export default {
  getRGB,
};